<template>
    <h3>Vista para pozos</h3>
</template>

<script>
export default {

}
</script>

<style>

</style>